import {} from 'graphql-schema';
export const ResolutionStatusEnum = Object.freeze({
    new: 'new',
    resolved: 'resolved',
    in_progress: 'in_progress',
});
export const IncidentReportFlagEnum = Object.freeze({
    green: 'green',
    yellow: 'yellow',
    red: 'red',
    black: 'black',
});
export const IncidentReportTypeEnum = Object.freeze({
    injury: 'injury',
    altercation: 'altercation',
    injury_and_altercation: 'injury_and_altercation',
});
export const ResolutionStatusLabels = Object.freeze({
    new: 'New',
    in_progress: 'In Progress',
    resolved: 'Resolved',
});
export const IncidentReportTypeLabels = Object.freeze({
    injury: 'Injury',
    altercation: 'Altercation',
    injury_and_altercation: 'Injury & Altercation',
});
export const IncidentReportFlagLabels = Object.freeze({
    green: 'Green',
    yellow: 'Yellow',
    red: 'Red',
    black: 'Black',
});
